import styled from 'styled-components';

const ModuleHeader = styled('h1')`
    font-size: 2em;
`

export default ModuleHeader;
